import { Avatar } from 'antd';
import Icon from 'assets/Icons';
import Box from 'components/Box';
import shopSelectors from 'services/shop/selectors';
import { ICleaningFeeItemStaff } from 'services/shop/types/cleaning-fee';
import styled from 'styled-components';
import SelectStaffsModal, { useSelectStaffsModalRef } from 'widgets/SelectStaffsModal';

interface StaffsSelectFormItemProps {
    value?: ICleaningFeeItemStaff[];
    onChange?: (value: ICleaningFeeItemStaff[]) => void;
}

const StaffsSelectFormItem = ({ value, onChange }: StaffsSelectFormItemProps) => {
    const staffs = shopSelectors.data.staffs();
    const addRef = useSelectStaffsModalRef();

    const handleChangeStaff = async () => {
        const selectedStaffs = await addRef.current?.open({
            staffs: staffs,
            activeStaffIds: value?.map((o: ICleaningFeeItemStaff) => o.staffId) || [],
        });
        if (selectedStaffs) {
            const newStaffs = selectedStaffs.map((o) => ({
                staffName: o.firstName,
                staffId: o.id,
                avatar: o.urlImage,
            }));
            onChange?.(newStaffs);
        }
    };
    const onRemoveStaff = (staff: ICleaningFeeItemStaff) => {
        const newStaffs = value?.filter((s) => s.staffId !== staff.staffId);
        onChange?.(newStaffs || []);
    };
    return (
        <Box display='flex' gap='3'>
            <OpenSelectStaffsModalButton type='button' onClick={() => handleChangeStaff()}>
                <Icon type='addPlus' />
            </OpenSelectStaffsModalButton>
            <StaffsContainer>
                {value?.map((staff) => (
                    <StaffItem key={staff.staffId}>
                        <Avatar src={staff.avatar} size={60} >
                            {staff.staffName?.[0] || 'A'}
                        </Avatar>
                        <StaffName>{staff.staffName}</StaffName>
                        <CloseButton type='button' onClick={() => onRemoveStaff(staff)}>
                            <IcClose />
                        </CloseButton>
                    </StaffItem>
                ))}
            </StaffsContainer>
            <SelectStaffsModal ref={addRef} />
        </Box>
    );
};

export default StaffsSelectFormItem;


const OpenSelectStaffsModalButton = styled.button`
    display: flex;
    width: 56px;
    height: 56px;
    padding: 16px 24px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 4px;
    border-radius: 100px;
    background: #C6E9EF;
`;

const StaffsContainer = styled.div`
    width: 100%;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(105px, 1fr));
    gap: 16px;
`;

const StaffItem = styled.div`
    position: relative;
    display: flex;
    padding: 4px 16px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 4px;
    border-radius: 8px;
    border: 1px solid #CCD4DC;
    background: #FFF;
`;

const CloseButton = styled.button`
    display: flex;
    width: 24px;
    height: 24px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    aspect-ratio: 1/1;
    position: absolute;
    right: -6.143px;
    top: -8px;
    border-radius: 100px;
    background: #ADADAD;
`;

const StaffName = styled.div`
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
    color: #1D2129;
    text-align: center;
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
`;


const IcClose = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path fillRule="evenodd" clipRule="evenodd" d="M13.4547 2.54486C13.7559 2.84613 13.7559 3.33458 13.4547 3.63585L3.63574 13.4548C3.33447 13.7561 2.84601 13.7561 2.54474 13.4548C2.24347 13.1535 2.24347 12.6651 2.54474 12.3638L12.3637 2.54486C12.665 2.24359 13.1534 2.24359 13.4547 2.54486Z" fill="white" />
        <path fillRule="evenodd" clipRule="evenodd" d="M2.54532 2.54486C2.84659 2.24359 3.33505 2.24359 3.63632 2.54486L13.4553 12.3638C13.7565 12.6651 13.7565 13.1535 13.4553 13.4548C13.154 13.7561 12.6655 13.7561 12.3643 13.4548L2.54532 3.63585C2.24405 3.33458 2.24405 2.84613 2.54532 2.54486Z" fill="white" />
    </svg>
);

